import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/Layout/Header/Header";
import Footer from "../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../components/Common/ScrollTop";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import SearchModal from "../../../components/Layout/Header/SearchModal";
// Image
import footerLogo from "../../../assets/img/logo/lite-logo.png";

import QuickLinks from "../../../components/Common/QuickLinks";
import { fetchData } from "../../../utils/fetchData";
import {
  getAPIPath,
  getMenu,
  getPageTitle,
} from "../../../utils/getDomainData";
const companies = [
  {
    name: "Company A",
    "2012-14": "Value1",
    "2013-15": "Value2",
    "2016-18": "Value3",
  },
  {
    name: "Company B",
    "2012-14": "Value4",
    "2013-15": "Value5",
    "2016-18": "Value6",
  },
  // Add more companies and data as needed
];
const SNTCampusPlacements = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetchData(getAPIPath()?.campus_placements, setData);
  }, []);
  const placements = data?.data || [];

  const uniqueCompanies = Array.from(
    new Set(
      placements.map(
        (item) =>
          item?.attributes?.campus_placements_company?.data?.attributes
            ?.Company_Name
      )
    )
  );
  const uniqueYears = Array.from(
    new Set(placements.map((item) => item?.attributes?.Year))
  );

  return (
    <React.Fragment>
      <Helmet>
        <title>Campus Placements – {getPageTitle()}</title>
        <meta name="description" content="" />
        <meta name="keywords" content=""></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <div className="pageTopOffset">
        <SiteBreadcrumb
          pageTitle="Campus Placements"
          pageName="Campus Placements"
          breadcrumbsClass="breadcrumb-bg"
        />
        {getMenu()}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col-lg-9 md-mb-30">
                <div className="content-wrapper">
                  <div className="content-section">
                    <h3 style={{ marginBottom: "20px" }} title="Campus Placements">Campus Placements</h3>
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th>Company Name</th>
                          {uniqueYears?.map((year, index) => (
                            <th key={index}>{year}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {uniqueCompanies?.map((company, index) => (
                          <tr key={index}>
                            <td>{company}</td>
                            {placements
                              .filter(
                                (placement) =>
                                  placement?.attributes
                                    ?.campus_placements_company?.data
                                    ?.attributes?.Company_Name === company
                              )
                              .map((placement, index) => (
                                <td key={index}>
                                  {placement?.attributes?.Number_of_Placements}
                                </td>
                              ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 pl-20 md-pl-14">
                <div className="about-intro">
                  <QuickLinks />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Accredation /> */}

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup secondaryColor" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default SNTCampusPlacements;
